import React, { useEffect, useRef, useState } from 'react';
import {
    Autocomplete,
    TextField,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    OutlinedInput,
    Typography,
    Chip,
} from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { APIEndpoints } from './APIEndpoints';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const times = ['7 AM', '8 AM', '9 AM', '10 AM', '11 AM', '12 PM', '1 PM', '2 PM', '3 PM', '4 PM', '5 PM', '6 PM', '7 PM'];

const SuggestTherapist = () => {
    const [selectedCells, setSelectedCells] = useState({});
    const [isDragging, setIsDragging] = useState(false);

    const therapistTableRef = useRef(null);
    const [fetching, setFetching] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showPhoneModal, setShowPhoneModal] = useState(false);

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const handlePhoneClose = () => setShowPhoneModal(false);
    const handlePhoneShow = () => setShowPhoneModal(true);

    const [previewMailData, setPreviewMailData] = useState({});
    const [previewPhoneData, setPreviewPhoneData] = useState({});
    const [selectedTherapist, setSelectedTherapist] = useState({});

    // Multiselect state
    const [county, setCounty] = useState([]);
    const [region, setRegion] = useState([]);
    const [title, setTitle] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [speciality, setSpeciality] = useState([]);
    const [therapistData, setTherapistData] = useState([]);
    const [childId, setChildId] = useState('');
    const [child, setChild] = useState(null);

    const [languagesList, setLanguagesList] = useState([]);
    const [specialityList, setSpecialityList] = useState([]);
    const [titleList, setTitleList] = useState([]);
    const [countyData, setCountyData] = useState([]);
    const [regionData, setRegionData] = useState([]);
    const [regionOptions, setRegionOptions] = useState([]);
    const [childList, setChildList] = useState([]);

    const [sortConfig, setSortConfig] = useState({ key: "title", direction: "asc" });

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };


    useEffect(() => {

        const selectedRegions = new Set();

        county.forEach((countyId) => {
            const regionsInCounty = regionData[countyId];
            if (regionsInCounty) {
                Object.entries(regionsInCounty).forEach(([regionId, regionName]) => {
                    selectedRegions.add(JSON.stringify({ Id: regionId, label: regionName }));
                });
            }
        });

        const regionArray = Array.from(selectedRegions).map((item) => JSON.parse(item));
        setRegionOptions(regionArray);
    }, [county, regionData]);


    const getData = async () => {
        try {
            const response = await axios.get(APIEndpoints.GET_SUGGESTED_THERAPISTS_PARAMS);
            const data = response?.data;
            setLanguagesList(data?.languages);
            setSpecialityList(data?.specialty);
            setTitleList(data?.title);
            const counties = data?.countyData;
            setCountyData(counties);
            setRegionData(data?.regionData);
            setChildList(data?.childData);
        } catch (error) {
            console.error(error);
        }
    };

    const submitData = async () => {
        setFetching(true);
        try {
            const county_dict_list = [];
            county.forEach((id) => {
                const county_dict = {};
                county_dict['Id'] = id;
                county_dict['Name'] = countyData[id];
                county_dict_list.push(county_dict);
            });

            const slots = Object.keys(selectedCells).map((key) => {
                const [day, time] = key.split('-');
                return {
                    day,
                    time,
                };
            });

            const payload = {
                countie_data: county_dict_list,
                region_data: region,
                title: title,
                language: languages,
                specialty: speciality,
                slot: slots,
                child_id: childId
            }

            const response = await axios.post(APIEndpoints.GET_SUGGESTED_THERAPISTS, payload);
            setTherapistData(response?.data);
            if (response?.data?.length <= 0) {
                toast.error("No Therapist Found", {
                    position: "top-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } else {
                setTimeout(() => {
                    const element = therapistTableRef.current;
                    console.log(element, '   element');

                    if (element) {
                        const rect = element.getBoundingClientRect();
                        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                        const elementTop = rect.top + scrollTop;
                        const offset = elementTop - (window.innerHeight / 2) + (element.offsetHeight / 2);

                        window.scrollTo({
                            top: offset,
                            behavior: 'smooth'
                        });
                    }
                }, 100);
            }

        } catch (error) {
            console.error(error);
        } finally {
            setFetching(false);
        }
    };

    const sortedTherapistData = React.useMemo(() => {
        let sortableData = [...therapistData];
        if (sortConfig.key) {
            sortableData.sort((a, b) => {
                let aVal = a[sortConfig.key] || '';
                let bVal = b[sortConfig.key] || '';

                // normalize for case-insensitive comparison
                aVal = typeof aVal === 'string' ? aVal.toLowerCase() : aVal;
                bVal = typeof bVal === 'string' ? bVal.toLowerCase() : bVal;

                if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
                if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
                return 0;
            });
        }
        return sortableData;
    }, [therapistData, sortConfig]);


    useEffect(() => {
        getData();
    }, []);

    const toggleCell = (day, time) => {
        const key = `${day}-${time}`;
        const updated = { ...selectedCells };
        if (updated[key]) {
            delete updated[key]; // unselect
        } else {
            updated[key] = true; // select
        }
        setSelectedCells(updated);
    };

    const toggleCellMultiple = (day, time, shouldSelect = true) => {
        const key = `${day}-${time}`;
        const updated = { ...selectedCells };
        if (shouldSelect) updated[key] = true;
        else delete updated[key];
        setSelectedCells(updated);
    };


    const handleMouseDown = (day, time) => {
        setIsDragging(true);
        toggleCell(day, time, true);
    };

    const handleMouseEnter = (day, time) => {
        if (isDragging) toggleCellMultiple(day, time, true);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const isCellSelected = (day, time) => !!selectedCells[`${day}-${time}`];

    const handleClear = () => {
        setSelectedCells({});
        setCounty([]);
        setRegion([]);
        setTitle([]);
        setLanguages([]);
        setSpeciality([]);
        setChildId('');
        setChild(null);
        setTherapistData([]);
        setPreviewMailData({});
        setPreviewPhoneData({});
        setSelectedTherapist({});
    }

    const handleChildChange = (e) => {
        handleClear();
        setTherapistData([]);

        const selectedId = e.target.value;
        const selectedChild = childList.find(c => c.Id === selectedId);

        setChildId(selectedId);
        setChild(selectedChild);

        const countyId = selectedChild?.county_id;
        if (countyId) {
            setCounty([countyId]);

            const regions = regionData[countyId];
            if (regions) {
                const selectedRegionsSet = new Set();
                Object.entries(regions).forEach(([regionId, regionName]) => {
                    selectedRegionsSet.add(JSON.stringify({ Id: regionId, label: regionName }));
                });
                const regionArray = Array.from(selectedRegionsSet).map(item => JSON.parse(item));
                setRegionOptions(regionArray);

                const regionId = selectedChild?.regin_id;
                const selectedRegionObj = regionArray.find(r => r.Id === regionId);
                if (selectedRegionObj) {
                    setRegion([selectedRegionObj]);
                }
            }

            setLanguages(selectedChild?.language ? [selectedChild.language] : []);

            if (selectedChild?.speciality) {
                const cleanedSpeciality = selectedChild.speciality.replace(/;/g, ',');
                setSpeciality(cleanedSpeciality.split(',').map(item => item.trim()));
            } else {
                setSpeciality([]);
            }

        }
    };

    const [sendingMail, setSendingMail] = useState(false);
    const [selectedMail, setSelectedMail] = useState('');
    const [sendingPhone, setSendingPhone] = useState(false);
    const [selectedPhone, setSelectedPhone] = useState('');

    const sendEmail = async () => {
        setSendingMail(true);

        const availability = Object.keys(selectedCells);

        const mail = selectedTherapist?.email;
        const child_id = childId;

        try {
            setSelectedMail(mail);
            const response = await axios.post(`${APIEndpoints.SEND_EMAIL}/`, {
                therapist_email: mail,
                child_id: child_id,
                availability: availability,
                mail_body: previewMailData?.body,
                mail_subject: previewMailData?.subject
            });
            if (response.status === 200) {
                handleClose();
                setPreviewMailData({});
                setSelectedTherapist({});
                toast.success("Email Sent Successfully", {
                    position: "top-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setSendingMail(false);
            setSelectedMail('');
        }
    }

    const cleanEmailBody = (text = "") => {
        return text
        .split('\n')                   
        .map(line => line.trim())      
        .filter(line => line !== '')  
        .join('\n');                   
    };


    const previewSendEmail = async (mail, child_id, therapist_id) => {

        if (!mail) {
            toast.error("Email is required", {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
            });
            return;
        }

        setSendingMail(true);

        const availability = Object.keys(selectedCells);

        try {
            setSelectedMail(mail);
            const response = await axios.post(`${APIEndpoints.PREVIEW_EMAIL}/`, {
                therapist_email: mail,
                child_id: child_id,
                availability: availability
            });
            if (response.status === 200) {
                handleShow();
                setPreviewMailData({
                    subject: response.data.subject,
                    body: cleanEmailBody(response.data.body)
                });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setSendingMail(false);
            setSelectedMail('');
        }
    }

    const sendPhone = async () => {
        setSendingPhone(true);

        const phone = selectedTherapist?.mobile;
        const child_id = childId;

        try {
            setSelectedPhone(phone);
            const response = await axios.post(`${APIEndpoints.SEND_PHONE}`, {
                therapist_phone: phone,
                child_id: child_id,
                notification_body: previewPhoneData?.body
            });
            if (response.status === 200) {
                handlePhoneClose();
                setPreviewPhoneData({});
                setSelectedTherapist({});
                toast.success("Notification Sent Successfully", {
                    position: "top-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setSendingPhone(false);
            setSelectedPhone('');
        }
    }

    const previewSendPhone = async (phone, mail, child_id, therapist_id) => {

        if (!phone) {
            toast.error("Phone number is required", {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
            });
            return;
        }

        setSendingPhone(true);

        const availability = Object.keys(selectedCells);

        try {
            setSelectedPhone(phone);
            const response = await axios.post(`${APIEndpoints.PREVIEW_EMAIL}/`, {
                therapist_email: mail,
                child_id: child_id,
                availability: availability
            });
            if (response.status === 200) {
                handlePhoneShow();
                setPreviewPhoneData({
                    subject: response.data.subject,
                    body: cleanEmailBody(response.data.body)
                });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setSendingPhone(false);
            setSelectedPhone('');
        }
    }

    return (
        <>
            <ToastContainer style={{ top: "2rem", position: "fixed" }} />
            <div className="container-fluid pt-4 px-3" onMouseUp={handleMouseUp}>


                <Box className="px-3 row gap-3 mb-2 mt-4">
                    <div className="col"><h4 className="mb-4 fw-semibold">Suggest Therapist</h4></div>
                    <div className="col-4">
                        <TextField
                            select
                            label="Child"
                            value={childId}
                            onChange={handleChildChange}
                            size='small'
                            fullWidth
                        >
                            {childList.map((option) => (
                                <MenuItem key={option?.Id} value={option?.Id}>
                                    {option?.Name || 'N/A'}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                </Box>

                <div className="d-flex align-items-center my-3 px-3">
                    <hr className="flex-grow-1 me-3" />
                    <span className="text-muted">OR</span>
                    <hr className="flex-grow-1 ms-3" />
                </div>

                <Box className="px-3 row gap-3">
                    <div className="col">
                        <FormControl sx={{ m: 0, width: '100%' }} size="small" fullWidth>
                            <InputLabel id="demo-multiple-name-label">County</InputLabel>
                            <Select
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                multiple
                                value={county}
                                size='small'
                                onChange={(e) => { setCounty(e.target.value); setRegion([]); }}
                                input={<OutlinedInput label="County" size='small' />}
                                renderValue={(selected) => {
                                    if (!selected.length) return null;

                                    const firstKey = selected[0];
                                    const firstLabel = countyData[firstKey]?.value || countyData[firstKey] || firstKey;
                                    const extraCount = selected.length - 1;

                                    return (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pl: 0.5 }}>
                                            <Typography variant="body2">{firstLabel}</Typography>
                                            {extraCount > 0 && (
                                                <Chip
                                                    label={`+${extraCount}`}
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: '#E0E7FF',
                                                        color: '#1E3A8A',
                                                        fontWeight: 500,
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    );
                                }}
                            >
                                {Object.entries(countyData)
                                    .sort((a, b) => {
                                        const aValue = typeof a[1] === 'string' ? a[1] : a[1].value;
                                        const bValue = typeof b[1] === 'string' ? b[1] : b[1].value;
                                        return aValue.localeCompare(bValue);
                                    })
                                    .map(([key, item]) => (
                                        <MenuItem key={key} value={key}>
                                            {typeof item === 'string' ? item : item.value}
                                        </MenuItem>
                                    ))}

                            </Select>
                        </FormControl>
                    </div>
                    <div className="col">
                        <Autocomplete
                            multiple
                            options={regionOptions.sort((a, b) => a.label.localeCompare(b.label))}
                            getOptionLabel={(option) => option.label}
                            value={region}
                            onChange={(e, val) => { setRegion(val); }}
                            size="small"
                            disableCloseOnSelect
                            renderTags={(selected) => {
                                if (selected.length === 0) return null;

                                const first = selected[0]?.label;
                                const extraCount = selected.length - 1;

                                return [
                                    <Box
                                        key="display"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            paddingX: 1,
                                        }}
                                    >
                                        <span style={{ fontSize: 14 }}>{first}</span>
                                        {extraCount > 0 && (
                                            <Chip
                                                label={`+${extraCount}`}
                                                size="small"
                                                sx={{
                                                    backgroundColor: '#E0E7FF',
                                                    color: '#1E3A8A',
                                                    fontWeight: 500,
                                                    height: 24,
                                                }}
                                            />
                                        )}
                                    </Box>,
                                ];
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Region"
                                    variant="outlined"
                                    size="small"
                                />
                            )}
                        />
                    </div>
                    <div className="col">
                        <Autocomplete
                            multiple
                            options={titleList}
                            value={title}
                            onChange={(e, val) => setTitle(val)}
                            size="small"
                            disableCloseOnSelect
                            renderTags={(selected) => {
                                if (selected.length === 0) return null;

                                const first = selected[0];
                                const extraCount = selected.length - 1;

                                return [
                                    <Box
                                        key="display"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            paddingX: 1,
                                        }}
                                    >
                                        <span style={{ fontSize: 14 }}>{first}</span>
                                        {extraCount > 0 && (
                                            <Chip
                                                label={`+${extraCount}`}
                                                size="small"
                                                sx={{
                                                    backgroundColor: '#E0E7FF',
                                                    color: '#1E3A8A',
                                                    fontWeight: 500,
                                                    height: 24,
                                                }}
                                            />
                                        )}
                                    </Box>,
                                ];
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Title"
                                    variant="outlined"
                                    size="small"
                                />
                            )}
                        />
                    </div>
                </Box>

                <Box className="px-3 row gap-3 mt-4">
                    <div className="col">
                        <Autocomplete
                            multiple
                            options={languagesList}
                            value={languages}
                            onChange={(e, val) => setLanguages(val)}
                            size="small"
                            disableCloseOnSelect
                            renderTags={(selected) => {
                                if (selected.length === 0) return null;

                                const first = selected[0];
                                const extraCount = selected.length - 1;

                                return [
                                    <Box
                                        key="display"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            paddingX: 1,
                                        }}
                                    >
                                        <span style={{ fontSize: 14 }}>{first}</span>
                                        {extraCount > 0 && (
                                            <Chip
                                                label={`+${extraCount}`}
                                                size="small"
                                                sx={{
                                                    backgroundColor: '#E0E7FF',
                                                    color: '#1E3A8A',
                                                    fontWeight: 500,
                                                    height: 24,
                                                }}
                                            />
                                        )}
                                    </Box>,
                                ];
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Languages"
                                    variant="outlined"
                                    size="small"
                                />
                            )}
                        />
                    </div>
                    <div className="col">
                        <Autocomplete
                            multiple
                            options={specialityList}
                            value={speciality}
                            onChange={(e, val) => setSpeciality(val)}
                            size="small"
                            disableCloseOnSelect
                            renderTags={(selected) => {
                                if (selected.length === 0) return null;

                                const first = selected[0];
                                const extraCount = selected.length - 1;

                                return [
                                    <Box
                                        key="display"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            paddingX: 1,
                                        }}
                                    >
                                        <span style={{ fontSize: 14 }}>{first}</span>
                                        {extraCount > 0 && (
                                            <Chip
                                                label={`+${extraCount}`}
                                                size="small"
                                                sx={{
                                                    backgroundColor: '#E0E7FF',
                                                    color: '#1E3A8A',
                                                    fontWeight: 500,
                                                    height: 24,
                                                }}
                                            />
                                        )}
                                    </Box>,
                                ];
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Speciality"
                                    variant="outlined"
                                    size="small"
                                />
                            )}
                        />
                    </div>
                    <div className="col d-flex gap-3">
                        <p className='btn btn-outline-danger px-4' onClick={() => handleClear()}>Clear All</p>
                    </div>
                </Box>

                {/* Time grid */}
                <div className="table-responsive p-3 mt-2">
                    <table
                        className="table table-borderless text-center align-middle"
                        style={{
                            border: '1px solid #dee2e6',
                            borderCollapse: 'collapse',
                            width: '100%',
                            userSelect: 'none',
                        }}
                    >
                        <tbody>
                            {days.map((day, i) => (
                                <tr key={i} className="small">
                                    <th
                                        className="text-center"
                                        style={{
                                            minWidth: 100,
                                            background: '#E5E7EB',
                                            padding: '16px 12px',
                                        }}
                                    >
                                        {day}
                                    </th>
                                    {times.map((time, j) => (
                                        <td
                                            key={j}
                                            onMouseDown={() => handleMouseDown(day, time)}
                                            onMouseEnter={() => handleMouseEnter(day, time)}
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: isCellSelected(day, time) ? '#E0E7FF' : 'transparent',
                                                color: isCellSelected(day, time) ? '#1E3A8A' : '#6B7280',
                                                padding: '16px 12px',
                                            }}
                                        >
                                            {time}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <small className='mb-1' style={{ 'font-weight': 'semi-bold' }}>
                        Note: Press <kbd>Ctrl</kbd> + Click to select multiple time slots
                    </small>

                    <div className="d-flex justify-content-end mt-3">
                        <div className='d-flex justify-content-end'>
                            <button className='btn px-5' style={{ background: '#E0E7FF', color: 'black' }} onClick={submitData}>
                                {fetching ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : 'Find Therapist'}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Therapist Table */}
                <div className='mt-3' ref={therapistTableRef}>
                    {therapistData.length > 0 && <h5 className="text-start px-3 mt-5 fw-bold">Available Therapist</h5>}
                    <div className="table-responsive p-3 mt-2">
                        {therapistData.length > 0 && (
                            <table
                                className="table table-bordered text-center align-middle"
                                style={{
                                    border: '1px solid #dee2e6',
                                    borderCollapse: 'collapse',
                                    width: '100%',
                                    userSelect: 'none',
                                }}
                            >
                                <thead className='text-center align-middle small'>
                                    <tr>
                                        {[
                                            { label: "Name", key: "name", width: 120, sortable: true },
                                            { label: "Title", key: "title", width: 160, sortable: true },
                                            { label: "County", width: 120 },
                                            { label: "Region", width: 180 },
                                            { label: "Language", width: 140 },
                                            { label: "Hours", width: 100 },
                                            { label: "Distance", width: 100 },
                                            { label: "Days", width: 160 },
                                            { label: "Mail", width: 120 },
                                            { label: "Phone", width: 100 },
                                        ].map((col, index) => (
                                            <th key={index} style={{ width: `${col.width}px`, background: '#E5E7EB', color: 'black', padding: '16px 12px', cursor: col.sortable ? 'pointer' : 'default', userSelect: 'none', }} onClick={col.sortable ? () => handleSort(col.key) : undefined}>
                                                {col.label}

                                                {col.sortable && (
                                                    <span style={{ fontSize: "12px", marginLeft: "8px", cursor: "pointer" }}>
                                                    {sortConfig.key === col.key
                                                        ? sortConfig.direction === "asc"
                                                        ? <i class="fa fa-sort-asc" aria-hidden="true"></i>
                                                        : <i class="fa fa-sort-desc" aria-hidden="true"></i>
                                                        : <i class="fa fa-sort" aria-hidden="true"></i>
}
                                                    </span>
                                                )}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {sortedTherapistData.map((therapist, index) => {
                                        return (
                                            <tr key={index} className="small text-center">
                                                <td>
                                                    <a href={`${process.env.REACT_APP_SF_URL}${therapist?.id}/view`} target="_blank" rel='noreferrer'>
                                                        {therapist?.name ? therapist.name.replace(/\b\w/g, char => char.toUpperCase()) : 'N/A'}
                                                    </a>
                                                </td>
                                                <td>{therapist?.title || 'N/A'}</td>
                                                <td>{therapist?.county || 'N/A'}</td>
                                                <td>{therapist?.region || 'N/A'}</td>
                                                <td>{therapist?.language?.replace(';', ', ') || 'N/A'}</td>
                                                <td>{therapist?.weeklyHoursAvailable ? `${therapist.weeklyHoursAvailable} hrs` : 'N/A'}</td>
                                                <td>{therapist?.distance || 'N/A'}</td>
                                                <td>{therapist?.availableTime || 'N/A'}</td>
                                                <td>
                                                    <button className='btn btn-light btn-sm' style={{ cursor: 'pointer', background: '#E0E7FF' }} onClick={() => { setSelectedTherapist(therapist); previewSendEmail(therapist?.email, childId, therapist?.id)}} disabled={(sendingMail && selectedMail === therapist?.email) || childId === ''}>
                                                        <i className='fa fa-envelope me-2'></i>Send
                                                    </button>
                                                </td>
                                                 <td>
                                                    <button className='btn btn-light btn-sm' style={{ cursor: 'pointer', background: '#E0E7FF' }} onClick={() => { setSelectedTherapist(therapist); previewSendPhone(therapist?.mobile, therapist?.email, childId, therapist?.id)}} disabled={(sendingPhone && selectedPhone === therapist?.phone) || childId === ''}>
                                                        <i className='fa fa-sms me-2'></i>Send
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>

            </div>


            <Modal show={showModal} onHide={handleClose} animation centered>
                <Modal.Body>
                    <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                        <h5 className="mb-0"><strong>Email Preview</strong></h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={handleClose}
                        />
                    </div>

                    <div className="form-group">
                        <div className='my-3'>
                            <label htmlFor="To">Subject</label>
                            <input
                                type="text"
                                className="form-control"
                                id="subject"
                                value={previewMailData?.subject}
                                onChange={(e) =>
                                    setPreviewMailData({ ...previewMailData, subject: e.target.value })
                                }
                            />
                        </div>
                        <div className='my-3'>
                            <label htmlFor="Body">Mail Body</label>
                            <textarea
                                className="form-control"
                                style={{
                                    padding: "1rem",
                                    fontFamily: "inherit",
                                    fontSize: "1rem",
                                    whiteSpace: "pre-wrap",
                                    minHeight: "200px",
                                }}
                                value={previewMailData?.body}
                                onChange={(e) =>
                                    setPreviewMailData({ ...previewMailData, body: e.target.value })
                                }
                                rows={6}
                            />
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="" 
                        style={{ background: "#E5E7EB", color: "#0A1E4F" }}
                        onClick={handleClose}
                        disabled={sendingMail || childId === ''}
                    >
                        Close
                    </Button>
                    <Button
                        variant="" 
                        style={{ background: "#E0E7FF", color: "#0A1E4F" }}
                        onClick={() => sendEmail()}
                        disabled={sendingMail || childId === ''}
                    >
                        {sendingMail ? (<i className='fa fa-spinner fa-spin mx-4'></i>) : (<> <i className='fa fa-envelope me-2'></i>Send</>)}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showPhoneModal} onHide={handlePhoneClose} animation centered>
                <Modal.Body>
                    <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                        <h5 className="mb-0"><strong>Notification Preview</strong></h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={handlePhoneClose}
                        />
                    </div>

                    <div className="form-group">
                        <div className='my-3'>
                            <label htmlFor="phoneBody">Notification Body</label>
                            <textarea
                                className="form-control"
                                style={{
                                    padding: "1rem",
                                    fontFamily: "inherit",
                                    fontSize: "1rem",
                                    whiteSpace: "pre-wrap",
                                    minHeight: "200px",
                                }}
                                value={previewPhoneData?.body}
                                onChange={(e) =>
                                    setPreviewPhoneData({ ...previewPhoneData, body: e.target.value })
                                }
                                rows={6}
                            />
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="" 
                        style={{ background: "#E5E7EB", color: "#0A1E4F" }}
                        onClick={handlePhoneClose}
                        disabled={sendingPhone || childId === ''}
                    >
                        Close
                    </Button>
                    <Button
                        variant="" 
                        style={{ background: "#E0E7FF", color: "#0A1E4F" }}
                        onClick={() => sendPhone()}
                        disabled={sendingPhone || childId === ''}
                    >
                        <i className='fa fa-sms me-2'></i>Send
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    );
};

export default SuggestTherapist;
